module.exports = __webpack_public_path__ + "assets/59fc8222bcd346f2d9ec24c2e4681fc2.png";